import { Flex, Box, Text } from '@chakra-ui/react';
import { ErrorIcon } from 'assets/icons/v2';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { ExternalRoutes } from 'types/Routes';

export const Disclaimer = (): ReactElement => {
  return (
    <Box
      borderRadius="10px"
      outline="1px solid"
      outlineOffset={-1}
      outlineColor="border.accent"
      boxSizing="border-box"
      position="relative"
      // As the overflow is on the left side we can't use the overflow clip
      overflowX="visible"
      mx={{ base: 'l', md: '40px' }}
    >
      <Box
        padding="15px 15px 15px 30px"
        position="relative"
        borderRadius="inherit"
        border="0px"
        overflowY="hidden"
      >
        <Box position="absolute" height="100%" left="0" top="0" overflow="visible">
          <Box bg="background.error" width="5px" height="100%" />
        </Box>
        <Flex flexDirection="column" gap="10px">
          <Text>
            Die bereitgestellten Informationen zu Medikamenten dienen lediglich zu
            Informationszwecken und ersetzen in keinster Weise die medizinische Beratung oder
            ärztliche Anordnung.
          </Text>
          <Link to={ExternalRoutes.DISCLAIMER}>
            <Text color="text.info">Mehr</Text>
          </Link>
        </Flex>
      </Box>
      <ErrorIcon
        position="absolute"
        color="icon.error"
        height="32px"
        width="32px"
        top="50%"
        left="2.5px"
        transform="translate(-50%, -50%)"
        zIndex="2"
      />
    </Box>
  );
};
